import { render, staticRenderFns } from "./PaymentCancel.vue?vue&type=template&id=7f84f30a&scoped=true"
import script from "./PaymentCancel.vue?vue&type=script&lang=js"
export * from "./PaymentCancel.vue?vue&type=script&lang=js"
import style0 from "./PaymentCancel.vue?vue&type=style&index=0&id=7f84f30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84f30a",
  null
  
)

export default component.exports